
import { repository } from 'src/jtech/jtech-repository'

export const ServiceRequestRepository = {

  nmInterfaceSigreInvoicesByUnid: 'sigre.invoicesByUnid',
  nmInterfaceSimpleAgreementsByUnid: 'sigre.simpleAgreementsByUnid',
  nmInterfaceInvoicesByUnid: 'invoice.invoicesByUnid',
  nmInterfaceFormFilter: 'serviceRequest.pesquisar',
  nmInterfaceDebitStatementByUnid: 'sigre.debitStatementFormByUnid',
  nmInterfaceValuesToCompensate: 'sigre.valuesToCompensateFormByUnid',
  nmInterfaceExemptionGravar: 'exemption.gravarExempt',
  nmInterfaceExemptionGravarForm: 'exemption.gravarExemptForm',
  nmInterfaceCreateFile: 'consumerUnitFile.create',

  sigreInvoicesByUnid: async function (sigreCode) {
    const { invoices } = await repository.resolveLogic(this.nmInterfaceSigreInvoicesByUnid, { id: sigreCode })
    return invoices
  },

  debitStatementFormByUnid: async function (sigreCode) {
    const { invoices } = await repository.resolveLogic(this.nmInterfaceDebitStatementByUnid, { id: sigreCode })
    return invoices
  },

  valuesToCompensateFormByUnid: async function (sigreCode) {
    const { invoices } = await repository.resolveLogic(this.nmInterfaceValuesToCompensate, { id: sigreCode })
    return invoices
  },

  invoicesByUnid: async function (consumerUnit, client) {
    const { registros } = await repository.resolveDatatableModel(this.nmInterfaceInvoicesByUnid, { consumerUnit: consumerUnit, client })
    return registros
  },

  simpleAgreementsByUnid: async function (sigreCode) {
    const { invoices } = await repository.resolveLogic(this.nmInterfaceSimpleAgreementsByUnid, { id: sigreCode })
    return invoices
  },

  formFilter: async function () {
    const form = await repository.resolve(this.nmInterfaceFormFilter)
    return form
  },

  serviceRequestExemptionForm: async function () {
    const form = await repository.resolve(this.nmInterfaceExemptionGravarForm)
    return form
  },

  serviceRequestExemptionRecord: async function (data) {
    await repository.resolveLogic(this.nmInterfaceExemptionGravar, { ...data })
  },

  createConsumerUnitFile: async function (data) {
    await repository.resolveLogic(this.nmInterfaceCreateFile, { ...data })
  }
}
